import { useEffect, useRef, useCallback } from 'react';

export const useSiteWideSpeechStop = () => {
    const synthRef = useRef<SpeechSynthesis | null>(null);

    const stopSpeech = useCallback(() => {
        const synth = synthRef.current ?? window.speechSynthesis;
        synthRef.current = synth;
        if (synth && (synth.speaking || synth.paused)) {
            synth.cancel();
        }
    }, []);

    useEffect(() => {
        const onAnyClick = () => stopSpeech();
        const onVisibilityChange = () => {
            if (document.hidden) stopSpeech();
        };
        const onBeforeUnload = () => stopSpeech();

        window.addEventListener('click', onAnyClick, { capture: true });
        document.addEventListener('visibilitychange', onVisibilityChange);
        window.addEventListener('beforeunload', onBeforeUnload);

        return () => {
            window.removeEventListener('click', onAnyClick, { capture: true } as any);
            document.removeEventListener('visibilitychange', onVisibilityChange);
            window.removeEventListener('beforeunload', onBeforeUnload);
        };
    }, [stopSpeech]);

    return { stopSpeech };
};
